import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const CostCustomSoftware7 = props => (
    <ServiceSection noPadTitle singleTitle icon={satelliteIcon} {...props} page="costCustomSoftware" section="accurateQuote">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="costCustomSoftware:accurateQuote" first />
            </div>
            <SatelliteTopics t={props.t} prefix="costCustomSoftware:accurateQuote" noGroupTitle tag="h3" />
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="costCustomSoftware:accurateQuote.closing" noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default CostCustomSoftware7;
